export const DOCUMENT_VIEWER_CONFIG = {
  // API endpoints
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://privacy-management.algosmic.com/api/v1',
  
  // Session settings
  HEARTBEAT_INTERVAL: 30000, // 30 seconds
  SESSION_WARNING_TIME: 300000, // 5 minutes before expiry
  
  // Chunk settings
  CHUNK_SIZE: 50000, // 50KB (should match backend)
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
  
  // Security settings
  ENABLE_WATERMARK: true,
  ENABLE_DEVTOOLS_DETECTION: true,
  ENABLE_SCREENSHOT_PREVENTION: true,
  
  // Canvas settings
  CANVAS_MAX_WIDTH: 1200,
  CANVAS_QUALITY: 0.9,
  DOC_ENC_ALG: 'fernet',                      // 'fernet' | 'none'
};

export const SECURITY_MESSAGES = {
  DEVTOOLS_DETECTED: 'Developer tools detected. Document viewing will be disabled for security.',
  SESSION_EXPIRED: 'Your viewing session has expired. Please request a new viewing session.',
  SESSION_CLOSING: 'Your session will expire in 5 minutes. Please save any notes.',
  DOWNLOAD_BLOCKED: 'Downloading is not permitted for security reasons.',
  SCREENSHOT_BLOCKED: 'Screenshots are disabled for this document.',
};